export enum DOCUMENTO_LIQUIDACION_TYPES {
    DL_SET_VIEW = 'DL_SET_VIEW',
    DL_SET_FORM_CLIENTE = 'DL_SET_FORM_CLIENTE',
    DL_HANDLE_ERRORS_CLIENTE = 'DL_HANDLE_ERRORS_CLIENTE',
    DL_SET_FORM_PRODUCTO = 'DL_SET_FORM_PRODUCTO',
    DL_SET_FORM_LIQUIDADOR = 'DL_SET_FORM_LIQUIDADOR',
    DL_HANDLE_ERRORS_PRODUCTO = 'DL_HANDLE_ERRORS_PRODUCTO',
    DL_HANDLE_ERRORS_LIQUIDADOR = 'DL_HANDLE_ERRORS_LIQUIDADOR',
    DL_SET_PRODUCTOS = 'DL_SET_PRODUCTOS',
    DL_SET_PRODUCTO_EDIT = 'DL_SET_PRODUCTO_EDIT',
    DL_SET_PRODUCTO_INDEX = 'DL_SET_PRODUCTO_INDEX',

    DL_ACTIVE_MODAL_EDITAR_PRODUCTO = 'DL_ACTIVE_MODAL_EDITAR_PRODUCTO',
    DL_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'DL_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    DL_ACTIVE_MODAL_QUITAR_TODO = 'DL_ACTIVE_MODAL_QUITAR_TODO',
    DL_ACTIVE_MODAL_EMITIR = 'DL_ACTIVE_MODAL_EMITIR',
    DL_ACTIVE_MODAL_EMITIDO = 'DL_ACTIVE_MODAL_EMITIDO',
    DL_ACTIVE_MODAL_MAS_OPCIONES = 'DL_ACTIVE_MODAL_MAS_OPCIONES',
    DL_ACTIVE_MODAL_ENVIAR_CORREO = 'DL_ACTIVE_MODAL_ENVIAR_CORREO',
    DL_ACTIVE_MODAL_IMPRIMIR = 'DL_ACTIVE_MODAL_IMPRIMIR',
    DL_ACTIVE_MODAL_ANULAR = 'DL_ACTIVE_MODAL_ANULAR',
    DL_ACTIVE_MODAL_ANULADO = 'DL_ACTIVE_MODAL_ANULADO',

    DL_SET_QR_CODE = 'DL_SET_QR_CODE',
    DL_SET_RESPONSE_EMITIR = 'DL_SET_RESPONSE_EMITIR',

    DL_SET_CALCULOS_PRODUCTO = 'DL_SET_CALCULOS_PRODUCTO',
    DL_SET_CALCULOS_GENERALES = 'DL_SET_CALCULOS_GENERALES',

    DL_RESTART_FORM_PRODUCTO = 'DL_RESTART_FORM_PRODUCTO',
    DL_RESTART_ALL = 'DL_RESTART_ALL',
    DL_SET_CLIENTE_ENCONTRADO = 'DL_SET_CLIENTE_ENCONTRADO',
    DL_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'DL_ACTIVE_MODAL_CLIENTE_ENCONTRADO',
    DL_SET_TABLE_PRODUCTOS = 'DL_SET_TABLE_PRODUCTOS',
    DL_SET_RETENCION_RENTA = 'DL_SET_RETENCION_RENTA',
}
